(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/receiver/components/search-result-item.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/receiver/components/search-result-item.js');
"use strict";


const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect;
const Icon = svs.ui.ReactIcon;
const SearchResultItem = _ref => {
  let result = _ref.result,
    index = _ref.index,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown;
  const itemRef = useRef(null);
  useEffect(() => {
    if (itemRef.current) {
      new svs.ui.RippleEffect(itemRef.current);
    }
  }, []);
  return React.createElement("li", {
    className: "tickets-order-home-list-item-link tickets-order-home-ripple-link u-flex border-bottom padding-1 padding-right-0 pointer u-flex-justify-content-between",
    "data-testid": "search-result-".concat(index),
    onClick: onClick,
    onKeyDown: onKeyDown,
    ref: itemRef,
    role: "button",
    tabIndex: 0
  }, React.createElement("div", {
    className: "u-flex"
  }, React.createElement(Icon, {
    className: "result-user-icon margin-right-half",
    icon: "user",
    size: "100"
  }), React.createElement("span", null, React.createElement("span", {
    className: "fw-500"
  }, result.firstName), ' ', React.createElement("span", {
    className: "fw-500"
  }, result.lastName), ", ", React.createElement("br", null), result.street, ", ", result.city)), React.createElement(Icon, {
    className: "u-flex-align-self-center margin-right-1",
    icon: "arrow-right",
    size: "100"
  }));
};
setGlobal('svs.ticketsOrderHome.orderHome.receiver.components.SearchResultItem', SearchResultItem);

 })(window);